import { Holding } from "../../../../app/bp/shed/types";
import { HoldingRole } from "./types";

export const roles = {

    [HoldingRole.Member]: {
        role: HoldingRole.Member,
        name: "Member",
        permissions: true
    },

    [HoldingRole.Owner]: {
        role: HoldingRole.Owner,
        name: "Owner",
        permissions: false
    },

    [HoldingRole.RestrictedMember]: {
        role: HoldingRole.RestrictedMember,
        name: "Restricted member",
        permissions: true
    },

}

export function getRoleName(role: HoldingRole) {
    return roles[role]?.name ?? `Unknown role ${role}`
}

export function isMemberRole(role: HoldingRole) {
    return (role === HoldingRole.Member) || (role === HoldingRole.RestrictedMember)
}
